// extracted by mini-css-extract-plugin
export var dividerContainer = "_8k-0";
export var line = "_8k-1";